import type { Market } from '~/utils/marketControl'

const MARKET_SITES = [
  { market: 'AU', zone: 'michaelhill.com.au', siteId: 'MichaelHillAU' },
  { market: 'NZ', zone: 'michaelhill.co.nz', siteId: 'MichaelHillNZ' },
  { market: 'CA', zone: 'michaelhill.ca', siteId: 'MichaelHillCA' },
] as const satisfies readonly { market: Market; zone: string; siteId: string }[]

// cf-worker carries the zone root (michaelhill.ca); the Host fallback carries the full domain.
const isZoneHost = (hostname: string, zone: string) => hostname === zone || hostname.endsWith(`.${zone}`)

/** The market a server request belongs to, or undefined when neither the host nor the local-dev siteId says. */
export function resolveRequestMarket(host?: string | null, siteId?: string): Market | undefined {
  const hostname = host?.split(':')[0].toLowerCase()
  const byHost = hostname ? MARKET_SITES.find(({ zone }) => isZoneHost(hostname, zone)) : undefined

  return (byHost ?? MARKET_SITES.find((site) => site.siteId === siteId))?.market
}

// Vue Router matches paths case-insensitively, so /FR/... resolves to the same fr routes.
export const isFrenchPath = (path: string) => /^\/fr(\/|$)/i.test(path)
